import { render, staticRenderFns } from "./satacSplash.vue?vue&type=template&id=51aa6cc4&scoped=true&"
import script from "./satacSplash.vue?vue&type=script&lang=js&"
export * from "./satacSplash.vue?vue&type=script&lang=js&"
import style0 from "./satacSplash.vue?vue&type=style&index=0&id=51aa6cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa6cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VLayout})
